import { STATUTS } from "@/lib/api";

const TONES = {
  success: "bg-emerald-50 text-emerald-800 border-emerald-200",
  warning: "bg-amber-50 text-amber-800 border-amber-200",
  danger: "bg-red-50 text-red-700 border-red-200",
  info: "bg-sky-50 text-sky-800 border-sky-200",
  muted: "bg-stone-100 text-stone-600 border-stone-200",
};

export function StatusBadge({ value, testId }) {
  const s = STATUTS[value] || { label: value || "—", tone: "muted" };
  return (
    <span data-testid={testId} className={`inline-flex items-center px-2 py-0.5 rounded border text-[11px] font-semibold whitespace-nowrap ${TONES[s.tone]}`}>
      {s.label}
    </span>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6">
      <div>
        <div className="h-1 w-10 bg-primary mb-3" />
        <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight" data-testid="page-title">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1 max-w-2xl">{subtitle}</p>}
      </div>
      {children && <div className="flex flex-wrap gap-2">{children}</div>}
    </div>
  );
}
